<div class="col-md-12" *ngIf="(isAdmin() | async)">
  <div class="m-portlet">
    <app-progress type="follower_comment"></app-progress>
    <div class="m-portlet__head">
      <h4>Comment time distribution from post added</h4>
    </div>
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaCommentAnalyze']"></div>
    <div class="col-12 m-portlet__body box-xl" [ngClass]="!(profileState | async).loader['audit']['mediaCommentAnalyze'] ? 'background-loader' : ''">
      <div *ngIf="chartsMediaCommentAnalyze !== undefined" [ngClass]="!((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''" >
        <h5>By hours (last 48 hours)</h5>
        <div [chart]="chartsMediaCommentAnalyze[0]"></div>
        <h5 class="m--margin-top-20">By days (between 2nd and 30th day from publication)</h5>
        <div [chart]="chartsMediaCommentAnalyze[1]"></div>
      </div>
      <div class="m--margin-top-20" *ngIf="chartsMediaCommentAnalyze === undefined || ((profileState | async).audit !== null && (profileState | async).audit.status === 0)">
        <div *ngIf="(profileState | async).audit !== null">
          <div class="pro-option m--margin-top-90" *ngIf="!((profileState | async).audit !== null && (profileState | async).audit.status)">
            <h4>Upgrade For Pro Analytics</h4>
            <i class="flaticon-rocket"></i>
            <a class="btn btn-blue btn-blue-hover" routerLink="/payment/add">Upgrade to PRO</a>
            <br>
            <a class="btn btn-default mt-4" routerLink="/demo">See sample reports</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
